import { api } from './networkService';

class DriverPaymentService {
    static async fetch(page, filters) {
        try {
            const response = await api.get(`api/user/payment/driver`, {
                params: {
                    page: page,
                    perPage: 20,
                    ...filters
                }
            });
            return response.data;
        } catch (error) {
            console.error('Fetch driver payment error:', error);
            throw error;
        }
    }

    static async fetchAll(filters) {
        try {
            const response = await api.get(`api/user/payment/driver`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch driver payment error:', error);
            throw error;
        }
    }

    static async fetchAllPdf(filters) {
        try {
            const response = await api.get(`api/user/payment/driver/all/pdf`, {
                params: filters
            });
            return response.data;
        } catch (error) {
            console.error('Fetch driver payment error:', error);
            throw error;
        }
    }

    static async add(driverPayment) {
        try {
            const cleanedDriverPayment = Object.fromEntries(
                Object.entries(driverPayment).filter(([_, value]) => value && value !== '')
            );
            const response = await api.post(`api/user/payment/driver`, cleanedDriverPayment);
            return response;
        } catch (error) {
            console.error('Add driver payment error:', error);
            throw error;
        }
    }

    static async fetchOne(id) {
        try {
            const response = await api.get(`api/user/payment/driver/${id}`);
            return response.data;
        } catch (error) {
            console.error('Fetch driver payment error:', error);
            throw error;
        }
    }

    static async delete(id) {
        try {
            const response = await api.delete(`api/user/payment/driver/${id}`);
            return response;
        } catch (error) {
            console.error('Delete driver payment error:', error);
            throw error;
        }
    }
}

export default DriverPaymentService;
